import { Firestore, addDoc, collection, serverTimestamp } from "firebase/firestore";
import { BulkAddSessionsFormValues } from "@/components/admin/locations/components/calendar/schemas/bulkAddSessionsSchema";

export interface EnqueueBulkJobResult {
  jobId: string;
}

export async function enqueueBulkSessionJob(
  db: Firestore,
  userId: string,
  locationId: string,
  formValues: BulkAddSessionsFormValues,
  dates: Date[]
): Promise<EnqueueBulkJobResult> {
  const jobsRef = collection(db, "bulkSessionJobs");

  // Serialize dates and extras for the job doc
  const isoDates = dates.map(d => d.toISOString());

  // Note: formValues may include Date instances (regEvents.when). They are not needed by the job, but safe to include.
  // Keep only fields needed by the worker to reduce payload size
  const {
    variationKey,
    displayTitle,
    description,
    eligibilityNotes,
    url,
    regUrl,
    availabilityStatus,
    signupStatus,
    numDaysOverride,
    myOfferIncrementKey,
    regEvents,
    createSingleDaysForOverlaps,
    singleDayTitleSuffix
  } = (formValues as any);

  const dateListExtras: Record<string, unknown> | undefined =
    typeof (formValues as any).dateListExtras === 'object'
      ? (formValues as any).dateListExtras
      : undefined;

  const docRef = await addDoc(jobsRef, {
    createdAt: serverTimestamp(),
    createdBy: userId,
    locationId,
    formValues: {
      variationKey,
      displayTitle,
      description: description ?? "",
      eligibilityNotes: eligibilityNotes ?? "",
      url: url ?? "",
      regUrl: regUrl ?? "",
      availabilityStatus,
      signupStatus,
      numDaysOverride: numDaysOverride ?? null,
      myOfferIncrementKey: myOfferIncrementKey ?? null,
      regEvents: regEvents ?? null,
      createSingleDaysForOverlaps: !!createSingleDaysForOverlaps,
      singleDayTitleSuffix: singleDayTitleSuffix ?? "",
      dateListExtras: dateListExtras ?? {}
    },
    dates: isoDates,
    status: "queued",
    processed: 0,
    total: isoDates.length,
    error: null
  });

  return { jobId: docRef.id };
}
